export function es() {
	return {
	  'form': {
	    'from': 'Desde',
	    'to': 'A',
	    'username': 'Nombre Usuario',
	    'password': 'Contraseña',
	    'type': 'Tipo',
	    'status': 'Estado',
	    'transactionPassword': 'Contraseña de Transaccion',
	    'confirmUsername': 'Confirmar Nombre Usuario',
	    'confirmPassword': 'Confirmar Contraseña',
	    'confirmTransactionPassword': 'Confirmar Contraseña de Transaccion',
	    'paymentOption': 'Opción de Pago',
	    'fromProduct': 'Desde Producto',
	    'email': 'Corre electrónico',
	    'website': 'Pagina Web',
	    'promotion': 'Promoción',
	    'advertisement': 'Anuncio',
	    'language': 'Idioma',
	    'size': 'Tamaño',
	    'campaign': 'Nombre de la Campaña',
	    'referralCode': 'Código de Referencia',
	    'newPassword': 'Nueva contraseña',
	    'iban': 'Numero de cuenta bancaria /IBAN',
	    'accountName': 'Nombre cuenta / Nombre Compañía',
	    'birthDate': 'Fecha de nacimiento',
	    'citizenship': 'Ciudadania',
	    'address': 'Direccion',
	    'swift': 'Código Banco (BIC) /SWIFT',
	    'bankName': 'Nombre Banco',
	    'bankAddress': 'Dirección Banco',
	    'isDefault': 'Usar como predeterminado',
	  },
	  'titles': {
	    'bankAccount': 'Cuneta de Banco',
	    'dashboard': 'Escritorio',
	    'account': 'Mi Cuenta',
	    'profile': 'Mi Perfil',
	    'transaction': 'Transacciones',
	    'transactionHistory': 'Historial de Transacciones',
	    'overview': 'Vision General',
	    'deposit': 'Depositos',
	    'withdrawal': 'Retiradas',
	    'transfer': 'Transferencias',
	    'productWallet': 'Transferencias (Cartera de productos)',
	    'p2pTransfer': 'Transferencias (Persona a persona)',
	    'skypeBetting': 'Apuestas por Skype',
	    'outstandingBets': 'Apuestas Abiertas',
	    'betHistory': 'Historial de Apuestas',
	    'betOverview': 'Resumen de apuestas',
	    'affiliate': 'Afiliados',
	    'affiliateDashboard': 'Escritorio de Afiliados',
	    'affiliateTools': 'Herramientas de Afiliados',
	    'supportTickets': 'Entradas de apoyo',
	    'settings': 'Ajustes',
	    'mobileSite': 'AMS Sitio Mobil',
	    'Valid Turnover/Commissions': 'Rotación Válida/Comisiones',
	    'products': 'Productos',
	    'size': 'Tamaño',
	    'campaign': 'Nombre Campaña',
	    'referralCode': 'Código de referencia',
	    'website': 'Pagina Web',
	    'tickets': 'Entradas de apoyo',
	  },
	  'tables': {
	    'product': 'Producto',
	    'memberId': 'Identificación del usuario',
	    'totalTurnover': 'Total TO',
	    'totalWinLoss': 'Ganancia/Pérdida del cliente',
	    'totalCommission': 'Comisión de Afiliados',
	    'date': 'Fecha',
	    'transactionNumber': 'Transacción #',
	    'type': 'Tipo',
	    'language': 'Idioma',
	    'currency': 'Moneda',
	    'paymentOption': 'Opción de Pago',
	    'amount': 'Cantidad',
	    'status': 'Estado',
	    'Total Commission': 'Comisión Total',
	    'subject': 'Tema',
	    'description': 'Descripcion',
	    'username': 'Nombre Usuario',
	    'balance': 'Balance',
	    'dateLastUpdated': 'Ultimo Dia Actualizado'
	  },
	  'Reset password': 'Restablecer contraseña',
	  'Activate Later': 'Activar mas tarde',
	  "You're on your way to earning a lifetime commission. Just follow 4 easy steps.": "Tienes la forma de ganar una comisión de por vida. Solo sigue estos 4 pasos sencillos",
	  'I confirm that I have read and accepted': 'Confirmo que he leido y aceptado',
	  'Asianconnect Affiliates Terms and Conditions': 'Términos y condiciones de Asianconnect Afiliados',
	  'Get Started': 'Empezar',
	  'Banners and Referral Codes': 'Banners y Codices de Referencia',
	  'Learn more': 'Aprender Mas',
	  'Archive': 'Archivo',
	  'generateBannerNote': 'Simplemente complete el formulario con los detalles de su campaña y generaremos un enlace de referencia y un banner para usted',
	  'Setup your username and password now': 'Configure ahora tu nombre de usuario y contraseña',
	  'Welcome to AC Affiliates!': 'Bienvenido a AC Afiliados!',
	  'Please enter your Campaign Name': 'Por favor introduzca el nombre de la campaña',
	  'Please enter your Referral Code': 'Por favor introduzca su Codigo de Referencia',
	  'Get code': 'Conseguir código',
	  'Reset': 'Reiniciar',
	  'Generate': 'Generar',
	  'referralCodeNote': 'Puede reutilizar su Codigo de Referencia existente o crear uno nuevo.',
	  'Special characters and spaces are not allowed.': 'Caracteres especiales y espacios no están permitidos',
	  'See Preview': 'Ver vista previa',
	  'Preview': 'Vista previa',
	  'Please enter your website URL': 'Por favor introduzca el URL de su pagina web',
	  'Please contact Customer Support.': 'Por favor contacte con el servicio al cliente',
	  'Change email': 'Cambiar correo electronico',
	  'Transfer from': 'Transferido de',
	  'Transfer to': 'Transferido a',
	  'Product': 'Producto',
	  'Please Select': 'Por favor seleccione',
	  'Commission Period': 'Periodo de Comision',
	  'Original Payout Date': 'Fecha de pago inicial',
	  'to': 'a',
	  'Reason': 'Motivo',
	  'commission': 'comision',
	  'Search': 'Buscar',
	  'Reset Filter': 'Reajustar Filtro',
	  'All Status': 'Todos los estados',
	  'Product Username': 'Nombre de usuario del Producto',
	  'All Payment Options': 'Opciones de pago',
	  'All types': 'Todos los tipos',
	  'Sign In': 'Registrarse',
	  'Sign in to start your session': 'Registre para iniciar su sesión',
	  'Please wait, Logging in...': 'Por favor espere blogueando',
	  'signOut': 'Desconecar',
	  'memberSince': 'Miembro desde',
	  'Note:': 'Notas:',
	  'Note': 'Notas',
	  'makeDeposit': 'Hacer deposito para incrementar fondos',
	  'welcome': 'Bienvenido a la pagina de miembros de Asianconnect',
	  'setup': 'Configura ahora tu nombre de usuario y contraseña',
	  'to activate your account.': 'activar tu cuenta',
	  'setupNote': 'Nota: Su nombre de usuario y contraseña temporales se enviaron a su correo electronico',
	  'Proceed': 'Proceder',
	  'Deposit Now': 'Depositar ahora',
	  'Available Balance': 'Saldo disponible',
	  'Unallocated Balance': 'Saldo no asignado',
	  'Account Status': 'Estado de la cuenta',
	  'Quick Links': 'Enlaces rapidos',
	  'BETA': 'BETA',
	  'Verified': 'Verificado',
	  'Not Verified': 'No Verificado',
	  'Filter': 'Filtrar',
	  'Request Transfer': 'Solicitud de trasnferencia',
	  'loadingPageContent': 'Cargando contenido de la pagina, por favor espere',
	  'Date Covered:': 'Fecha Cubierta:',
	  'Total Turnover:': 'Facturación Total:',
	  'Total Affiliate Commission:': 'Comisión Total de Afiliados:',
	  'Total Customer W/L:': 'Ganancia/Perdida Total del Ciente:',
	  'exportCsv': 'Exportar a CSV',
	  'noProduct': 'Sin producto',
	  'somethingWentWrong': 'Algo salió mal. Por favor comprueba tus detalles.',
	  'activated': 'Has activado exitosamente su cuenta.',
	  'Account Activation': 'Activación de la cuenta',
	  'activateAccountNote': 'Active a continuación su cuenta activado sus credenciales',
	  'usernameValidation': 'Solo debe contener números, letras y guiones.',
	  'passwordValidation': 'Debe tener al menos 8 caracteres que contentan al menos 2 letras, 2 números y 2 simbolos',
	  'transactionPasswordValidation': 'Debe ser alfanumerico con un mínimo de 6 caracteres y tener al menos una letra mayuscula',
	  'Re-enter username': 'Vuelva a ingresar nombre de usuario',
	  'Re-enter password': 'Escriba otra vez la contraseña',
	  'Re-enter transaction password': 'Vuelva a ingresar la contraseña de la transaccion',
	  'Activate account': 'Activar la cuenta',
	  'Clear All': 'Borrar todo',
	  'skrillContent': 'Inicie sesión en su cuenta SKRILL y transfiera los fondos solicitados ',
	  'netellerContent': 'Inicie sesión en su cuenta NETELLER y transfiera los fondos solicitados ',
	  'verifyDeposit': 'Estamos verificando su deposito. Una vez que recibamos su depósito, vera los fondos adicionados.',
	  'netellerTransferNote': 'Inicie sesión en su cuenta NETELLER y transfiera los fondos solicitados ',
	  'netellerTransferNote2': 'con código de transferencia de ',
	  'you will see the additional funds reflected in your account.': 'Vera los fondos adicionales reflejados en su cuenta',
	  'CONTINUE': 'Continuar',
	  'cantProcessRequest': "Lo sentimos, no hemos podido procesar su solicitud en este momenot",
	  'Sorry': 'Lo siento',
	  'Thank you': 'Gracias',
	  'OK': 'Vale',
	  'For making a deposit': 'Para hacer un depósito',
	  'We are now verifying your deposit. Once we have received your deposit,': 'Estamos verificado su deposito. Una vez que hayamos recibido su deposito',
	  'bankNotice': 'Las transferencias bancarias esta restringida en este momento. Para consolas por favor contacte con el servicio al cliente . Gracias',
	  'bankRestricted': 'Transferencias bancas están restringidas en su pais. Por favor, utilice otros metodos de pago. Por favor utilice otro método de pago.',
	  'processingTime': 'Tiempo de procesamietno',
	  'fee': 'Tasas',
	  'minimumDeposit': 'Mínima cantidad de depósito',
	  'maximumDeposit': 'Máxima cantidad de depósito',
	  'chooseProductDeposit': 'Simplemente elija su producto preferido (casa de apuestas), ingrese la cantidad y luego haga clic en Solicitar Depósito',
	  'Product Name': 'Nombre del producto',
	  'Amount': 'Cantidad',
	  'fileValidation': 'Solo se permiten archivos jpg jeeps y png con un máximo de 2MB',
	  'Transaction Summary': 'Resumen de transacciones',
	  'Total amount to be deposited in your account': 'Importe total a depositar en su cuenta',
	  'Total amount to be sent in your account': 'Importe total a enviar a su cuenta',
	  'You have submitted the BTC deposit request form.': 'Usted ha enviado el formulario de solicitud de depósito de BTC',
	  'Please send the BTC amount to the BTC address below. This address is unique to your account.': 'Por favor envíe el monto de BTC al a la siguiente dirección de BTC. Esta dirección es única para su cuenta.',
	  'Tap or Scan to pay': 'Toque o escanee para pagar',
	  'Show QR': 'Mostar QR',
	  'Total BTC to be sent': 'BTC total a enviar',
	  'Recipient BTC Address': 'Dirección BTC del destinatario',
	  'Please send total BTC to the recipient address.': 'Por favor envíe el total de BTC a la dirección del destinatario.',
	  'Copy': 'Copiar',
	  'Rate Used per BTC': 'Tarifa utilizada por BTC',
	  'Please send bitcoin in': 'Por favor envie bitcoin en',
	  'minutes.': 'minutos.',
	  'This page will automatically refresh when Bitcoin has been sent.': 'Esta página se actualizará automáticamente cuando se haya enviado los Bitcoins.',
	  'Thank you for sending the requested amount!': 'Gracias por enviar la cantidad solicitada¡',
	  'We are now waiting for your Bitcoin confirmations.': 'Estamos esperando la confirmación de sus Bitcoins.',
	  'confirmation(s) received': 'confirmación recibida',
	  'Status': 'Estado',
	  'Thank you for making a deposit!': 'Gracias por hacer un depósito¡',
	  'We are now verifying your deposit. Once we have received your deposit, you will see the additional funds reflected in your account.': 'Estamos verificado su depósito. Una vez que hayamos recibido su depósito, vera los fondos adicionales reflejados en su cuenta.',
	  'We are now waiting to receive your bitcoin. The page will automatically update when the bitcoin has been received.': 'Estamos a la espera de recibir sus bitcoins. La pagina se actualizará automáticamente cuando se haya recibido los bitcoins.',
	  'Requested: waiting to receive bitcoin': 'Solicitado: a la espera de recibir bitcoin',
	  'Note: Please contact Support if you made a request by mistake and would like to request again': 'Nota: Póngase en contacto con el Servicio de asistencia técnica si realizó una solicitud por error y desea solicitarla de nuevo',
	  'bitcoinDeclined': "Dispulce, su solicitud fue DECLINADA probablemente porque no recibimos sus bitcois. Si se trata de un error, póngase en contacto con nuestro servicio de asistencia y le atenderemos de inmediato",
	  'Close': 'Cerrar',
	  'Exchange Rate': 'Tipo de cambio',
	  'Note: Deposit rate is updated real-time and rate will be locked upon submission of your request.': 'Nota: La tasa de depósito se actualiza en tiempo real, y se bloqueara una vez recibida su solicitud.',
	  'Total BTC amount to send:': 'Cantidad total de BTC a enviar:',
	  'Total EUR amount to receive:': 'Importe total de EUR a recibir:',
	  'Transaction Status': 'Estado de la transacción',
	  'Requested': 'Pedido',
	  'Pending Confirmation': 'Pendiente de confirmación',
	  'Confirmed': 'Confirmado',
	  'Declined': 'Rechazad',
	  'Voided': 'Anulado',
	  'Account ID': 'ID de la cuenta',
	  'Amount to deposit': 'Cantidad a depositar',
	  'Total amount to deposit': 'Importe total a depositar',
	  'Free': 'Gratis',
	  'Add product': 'Añadir Producto',
	  'Make new request': 'Hacer una nueva solicitud',
	  'we will send you the username and password of your newly registered account.': 'le enviaremos el nombre de usuario y la contraseña de su cuenta recién registrada.',
	  'Total amount to be deposited on account': 'Importe total a depositar en su cuenta',
	  'Total amount to be deducted from account': 'Importe total a deducir de su cuenta',
	  'Total amount to be sent': 'Importe total a enviar',
	  'Total amount to be received': 'Importe total a recibir',
	  'Enter product username': 'Introduzca el nombre de usuario del producto',
	  'Total amount to send': 'Importe total a enviar',
	  'Request is successfully created!': 'La solicitud se ha creado correctamente.',
	  'Please wait for customer service confirmation. You can view transaction status in Transactions overview.': 'Por favor, espere la confirmación del servicio al cliente. Puede ver el estado de la transacción en el Resumen de Transacciones.',
	  'Unable to Transfer': 'No se puede transfer',
	  'Please contact our customer service team to have your account verified. Thank you.': 'Póngase en contacto con nuestro servicio de atención al cliente para verificar su cuenta. Gracias',
	  'No product(s) available for selection.': 'No hay productos disponibles para la selección',
	  'Opps, amount is not enough!': 'Apps la cantidad no es suficiente¡',
	  'Minimum amount that can be withdrawn is 100 EUR/GBP.': 'La cantidad mínima que se puede retirar son 100 EUR/GBP',
	  'Do you want ': 'Quieres ',
	  'to be your default bank for withdrawal?': 'que sea tu banco por defecto para el retiro?',
	  'You have selected Bankwire as your preferred payment gateway. If you would like to choose other payment gateways instead, please click on the next tabs.': 'Ha seleccionado Transferencia bancaria como su método de pago preferido. Si desea elegir contro método de pago, haga clic en las siguientes pestañas.',
	  'Minimum Withdrawal Amount': 'Cantidad mínima de retiro',
	  'Maximum Withdrawal Amount': 'Cantidad máxima de retiro',
	  'Bank Account': 'Cuenta bancaria',
	  'Link new bank account': 'Vincular nueva cuenta bancaria',
	  'transactionPasswordHint': 'Sugerencia: Si ha sido un cliente existente desde Marzo de 2017 y no ha configurado su contraseña de transacción, esta es su respuesta a la pregunta de seguridad: Cual es su trabajo soñado?',
	  'Beneficiary name': 'Nombre del beneficiario',
	  'Beneficiary address': 'Dirección del beneficiario',
	  'IBAN': 'IBAN',
	  'Bank name': 'Nombre del banco',
	  'Bank address': 'Dirección del banco',
	  'SWIFT': 'SWIFT',
	  'Total amount to be deducted from your account': 'Importe total a deducir de su cuenta',
	  'Total amount to be received in your account': 'Importe total a recibir en su cuenta',
	  'Confirmation Message': 'Mensaje de confirmacion',
	  'Yes': 'Sí',
	  'No': 'No',
	  'confirmations': 'Confirmación',
	  'Please select product(s) where you want to withdraw, and input the amount in': 'Por favor seleccione los productos en los que desea retirar e ingrese la cantidad en',
	  'or BTC': 'o BTC',
	  'Total BTC': 'Total BTC',
	  'SEND TO': 'Enviar a',
	  'Please make sure that your Bitcoin address is correct. We will send your BTC to this address.': 'Por favor, asegúrese de que su dirección de Bitcoin es correcta. Le enviaremos su BTC a esta dirección.',
	  'Total BTC amount to receive': 'Total BTC a recibir',
	  'Total': 'Total',
	  'amount to be deducted': 'importe a ser deducido',
	  'Amount to deduct': 'Importe a deducir',
	  'Total amount to receive': 'Total importe a recibir',
	  'Opps, we need to know where to wire your funds.': 'Oops necesitamos saber dónde transferir sus fondos',
	  'Please fill in the required bank details. Thank you!': 'Por favor complete los datos bancarios requeridos. Gracias¡',
	  'Unable to withdraw': 'No se puede retirar',
	  'Invalid Action!': 'Acción no valida¡',
	  'A product where the fee should be charged is required.': 'Se requiere producto donde se deba cobrar la tarifa.',
	  'Reset link was sent to your email.': 'Restablecer enlace fue enviado a su correo electrónico',
	  'Success!': 'Exito!',
	  'Send reset password link': 'Enviar enlace restablecer contraseña',
	  "Enter the email you use for Asianconnect88, and we'll help you create a new password.": "Ingrese el correo electrónico que usa para Asiancconnect88 y te ayudaremos con una nueva contraseña",
	  'English': 'Inglés',
	  'French': 'Francés',
	  'German': 'Alemán',
	  'Spanish': 'Español',
	  'Asian Odds': 'Asian Odds',
	  'Note: Referral URL is your unique link where you can share to everyone': 'Nota: La URL de referencia es su enlace único que puede compartirlo con todo el mundo',
	  'Referral HTML Code': 'Código HTML de referencia',
	  'copyReferralCodeNote': 'Simplemente copia o descarga el código HTML de su campana y péguelo en la sección de su página web donde desee mostrarlo',
	  'Download HTML': 'Descargar HTML',
	  'Terms and Conditions': 'Términos y condiciones',
	  'and': 'y',
	  'Commission Scheme': 'Esquema de comisiones',
	  'apply': 'aplicar',
	  'Referral URL': 'URL de referencia',
	  'Note: Your Referral URL is a unique link which you can use to refer new members to Asianconnect.': 'Nota: Su URL es un único enlace que puede usar para recomendar nuevos miembros a Asianconnect',
	  'Information': 'Información',
	  'Get a unique tracking link for your campaign.': 'Obtenga un enlace de seguimiento único para su campaña.',
	  'Website. Input your website URL.': 'Sitio web. Introduzca la URL de su sitio web',
	  'Banner type. Pick a banner type: (language/size/promo)': 'Tipo de banner. Elija un tipo de banner (idioma/tamaño/promoción)',
	  'Campaign. Name your campaign.': 'Campaña. Nombra tu campaña.',
	  'Tracking code. Do you have a preferred tracking code? Input preferred tracking code. Click on generate.': 'Código de localización. Tienes un código de seguimiento preferido?. Introduzca el código de seguimiento preferido. Haga clic Generar.',
	  'Your Referral Code URL/s is a unique link which you can use to refer new  members to Asianconnect.': 'Su Codigo de Referencia URL es un enlace único que pude usar para recomendar a nuevos mientras a Asianconnect',
	  'campaignNote': 'Simplemente copie o descargue el código HTML de su campaña y péguelo en la sección donde desea que e muestre el banner en su sitio web',
	  'Preview archived banner': 'Vista previa del banner archivado',
	  'Uploaded': 'Subido',
	  'Drag and drop files here or': 'Arrastar y soltar archivos aquí',
	  'Select file(s)': 'Selección archivos',
	  'Only .jpg, .jpeg, docx, doc, pdf and .png with maximum of 2MB is allowed.': 'Solo se permite .jp .jpeg .docx doc pdf -png con un máximo de 2MB',
	  'file(s) selected. Click upload to proceed.': 'archivo(s) seleccionado(s). Haga click en subir para continuar',
	  'The file is too large (MB). Allowed maximum size is 2MB.': 'El archivo es demasiado grande (MB). El tamaño máximo permitido es de 2MB.',
	  'Only .jpeg , .jpg , .png , .pdf , .doc and .docx are allowed.': 'Solo se permiten .jpeg .jpg .png .pdf .doc y .docx son permitidos',
	  'Successfully uploaded!': 'Cargado con éxito!',
	  'Documents uploaded': 'Documentos subidos',
	  'Delete Document': 'Eliminar documento',
	  'Are you sure you want to delete this document?': 'Estás seguro que quieres eliminar este documento?',
	  'Cancel': 'Cancelar',
	  'Delete': 'Borrar',
	  'Account Information': 'Información de la cuenta',
	  'Customer ID': 'Identificación de la cuenta',
	  'Full name': 'Nombre completo',
	  'Currency': 'Moneda',
	  'Country': 'País',
	  'Date of birth': 'Fecha de nacimienot',
	  'Join date': 'Fecha de ingreso',
	  'Email Address': 'Correo electrónico',
	  'Phone number': 'Número de teléfono',
	  'Skype': 'Skype',
	  'Username': 'Nombre de usuario',
	  'K.Y.C documents': 'Documentos de K.Y.C',
	  'Password changed.': 'Contraseña cambiada',
	  'I want to request a new reset code.': 'Quiero solicitar un nuevo código de reinicio',
	  'Loading, please wait...': 'Cargando por favor espere…',
	  'Request new reset code?': 'Solicitar nuevo código de reinicio?',
	  'Enter your new account password below.': 'Introduzca su nueva contraseña a continuación',
	  'Account password has been successfully updated!': 'La contraseña de la cuenta ha sido actualizada exitosamente!',
	  'Update AMS account password': 'Actualizar la contraseña de la cuenta AMS',
	  'Current AMS password': 'Contraseña actual de AMS',
	  'New AMS Password': 'Nueva contraseña de AMS',
	  'Enter current password': 'Introduzca la contraseña actual',
	  'Enter new password': 'Introduzca la contraseña nueva',
	  'Confirm new password': 'Confirma la nueva contraseña',
	  'Update': 'Actualizar',
	  'Are you sure you want to delete this Bank Account?': 'Esta seguro de que desea eliminar esta cuenta bancaria?',
	  'Add bank accounts for faster transaction.': 'Añadir cuentas bancarias para una transacción mas rápida',
	  'Default': 'Defecto',
	  'Link a new bank account': 'Vincular una nueva cuenta bancaria',
	  'Bank account successfully deleted.': 'Cuenta bancaria eliminada con éxito',
	  'Success': 'Éxito',
	  'Transaction password has been successfully updated!': 'Contraseña de transacción actualizada con éxito',
	  'Update AMS transaction password': 'Actualizar la contraseña de transacción de AMS',
	  'Current AMS transaction password': 'Contraseña de transacción actual de AMS',
	  'Enter current transaction password': 'Ingrese la contraseña de transacción de AMS',
	  'New AMS transaction password': 'Nueva contraseña de transacción de AMS',
	  'Enter new transaction password': 'Introduzca una nueva contraseña de transacción',
	  'Confirm new transaction password': 'Confirmar nueva contraseña de transacción',
	  'Account username has been successfully updated!': 'El nombre de usuario de la cuenta se ha actualizado correctamente',
	  'Update AMS username': 'Actualizar el nombre de usuario de AMS',
	  'Current AMS username': 'Nombre usuario actual de AMS',
	  'New AMS username': 'Introduce un nuevo nombre de usuario de AMS',
	  'Enter new username': 'Introduce nuevo nombre de usuario',
	  'Confirm new username': 'Confirmar nuevo nombre de usuario',
	  'Enter password': 'Introducir contraseña',
	  'Security': 'Seguridad',
	  'Update your Username, Account and Transaction Password': 'Actualice su cuenta de usuario y contraseña de la transacción',
	  'Temporarily Unavailable': 'Temporalmente no disponible',
	  'For inquiries, please contact Customer Support.': 'Para consultas, póngase en contacto con Atención al cliente',
	  'Payment Option': 'Opciones de pago',
	  'Manage your payment accounts': 'Gestiona tus cuentas de pago',
	  'Open': 'Abierto',
	  'Pending': 'Pendiente',
	  'Resolved': 'Resuelto',
	  'Closed': 'Cerrado',
	  'Forbidden!': 'Prohibido!',
	  'My Products': 'Mis productos',
	  'Add Product': 'Añadir producto',
	  'Reset Product Password': 'Restablecer contraseña del producto',
	  'New': 'New',
	  'Bank account successfully created.': 'Cuenta bancaria creada con éxito.',
	  'Link a bank account': 'Vincular una cuenta bancaria',
	  'Enter Account Number': 'Ingrese numero de cuenta',
	  'Enter Account Name': 'Ingrese nombre de la cuenta',
	  'Enter Citizenship': 'Ingrese Ciudadanía',
	  'Enter Address': 'Ingrese Dirección',
	  'Enter Bank Code': 'Ingrese Código Bancario',
	  'Enter Bank Name': 'Ingrese Nombre del Banco',
	  'Enter Bank Address': 'Ingrese Dirección del Banco',
	  'Save bank account': 'Guardar cuenta bancari',
	  'Save': 'Guardar',
	  'Limit Reached!': 'Limite alcanzado',
	  'Go to Settings': 'Ir a la configuración',
	  'Product password successfully requested.': 'Contraseña del producto solicitada con éxito',
	  'Warning': 'Advertencia',
	  'Something went wrong. Please try again later.': 'Algo salió mal. Por favor, intento de nuevo más tarde.',
	  'Request Product Password': 'Solicitar contraseña del producto.',
	  'Select one or more products to reset password': 'Seleccione uno o mas productos para restablecer la contrseña.',
	  'View Password': 'Ver contraseña',
	  'Expires on': 'Expira el',
	  'Expired Password': 'Contraseña Caducada',
	  'No Password': 'Sin Contraseña',
	  'Enter Transaction Password': 'Introduzca la contraseña de la transaccion',
	  'Request': 'Solicitud',
	  'Product password will be available once password has been reset.': 'La contraseña del producto estará disponible una vez que la contraseña se haya restablecido',
	  'Warning!': 'Advertencia!',
	  'Warning! The following product/s has pending request': 'Advertencia!. El siguiente producto/s tiene una solicitud pendiente',
	  'Request Product': 'Solicitar producto',
	  'Please select at least one product below': 'Por favor seleccione al menos un producto a contiuacion',
	  'No products available. You already have all the products Asianconnect offers.': 'No hay productos disponibles. Ya tienes todos los productos que ofrece Asianconnect',
	  'username': 'Nombre de usuario',
	  'SINGBET FORCED POSITION TAKING ON ASIANCONNECT': 'POSICIÓN FORZADA QUE TOMA ASIANCONNECT DE SINGBET',
	  'Profit and Loss (PnL)': 'Pérdidas y Ganacias (PyG)',
	  'Please note that your win(profit)/loss on SINGBET is always PnL*0.40.': 'Tenga en cuenta que su ganancia/pérdida en SINGBET es siempre (PyG) *0,40',
	  'So if your wager is 1000 and you win, you only win 400 EUR/GBP (1000*.040).': 'Entonces, si su apuesta es 1000 euros y gana, solo ganaría 400 EUR/GBP (1000*0,40)',
	  'Then if you lose, you only lose 400 EUR/GBP.': 'Entonces, si pierdes, solo perderá 400 EUR/GBP',
	  'Deposits': 'Depósitos',
	  'Your deposit on SINGBET is always amount/0.40. This means that if you send 1000 EUR/GBP, we will add 2500 (1000/0.40=2500) to your SINGBET credit.': 'Su depósito en SINGBET es siempre de /0,40. Esto significa que si envía 1000 EUR/GBP agregaremos 2500 (1000/0.4=2500) a su cuenta de crédito de SINGBET.',
	  'Withdrawals': 'Retiradas',
	  'Likewise, your withdrawal amount is /0.40. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2500 (1000/0.40) from your SINGBET credit.': 'Igualmente su cantidad de retiro es /0.40. Esto significa que si desea retirar 1000 EUR/GBP, deduciremos 2500 (1000/0,4) de su crédito de SINGBET.',
	  'In AMS Account will appear EUR/GBP money, however in your Singbet account is Singbet money.': 'En la cuenta AMS aparecerá el dinero EUR/GBP, sin embargo, en su cuenta de SINGBET aparecera el dinero de SINGBET.',
	  'I agree to the Terms and Conditions': 'Estoy de acuerdo con los términos y condiciones.',
	  'MAXBET FORCED POSITION TAKING ON ASIANCONNECT': 'POSICIÓN FORZADA QUE ASIANCONNECT TOMA DE MAXBET',
	  'Please note that your win(profit)/loss on MAXBET is always PnL*0.50.': 'Tenga en cuenta que su ganancia/pérdida en MAXBET es siempre (PyG)*0,50',
	  'So if your wager is 1000 and you win, you only win 500 EUR/GBP (1000*.050).': 'Entonces, si su apuesta es 1000 y gana, solo gana 500 EUR/GBP (1000*0,50)',
	  'Then if you lose, you only lose 500 EUR/GBP.': 'Entonces, si pierdes, solo perderá 500 EUR/GBP',
	  'Your deposit on MAXBET is always amount/0.50. This means that if you send 1000 EUR/GBP, we will add 2000 (1000/0.50=2000) to your MAXBET credit.': 'Su depósito en MAXBET es siempre de /0,50. Esto significa que si envia 1000 EUR /GBP agregaremos 2000 (1000/0,50=2000) a su cuenta de crédito de MAXBET.',
	  'Likewise, your withdrawal amount is /0.50. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 2000 (1000/0.50) from your MAXBET credit.': 'Igualmente su cantidad de retiro es /0.50. Esto significa que si desea retirar 1000 EUR/GBP, deduciremos 2000 (1000/0,5) de su crédito de MAXBET.',
	  'In AMS Account will appear EUR/GBP money, however in your Maxbet account is Maxbet money.': 'En la cuenta AMS aparecerá el dinero EUR/GBP, sin embargo, en su cuenta de MAXBET aparecera el dinero de MAXBET.',
	  'SBOBET Forced Position Taking ON ASIANCONNECT': 'POSICION FORZADA QUE ASIANCONNECT TOMA DE SBOBET',
	  'Please note that your win(profit)/loss on SBOBET is always PnL*0.30. So if your wager is 1000 and you win, you only win 300 EUR/GBP (1000*.30).Then if you lose, you only lose 300 EUR/GBP.': 'Tenga en cuenta que su ganancia/pérdida en SBOBET es siempre (PyG)*0,30. Entonces, si su apuesta es 1000 y gana, solo gana 300 EUR/GBP (1000*0,30). Entonces, si pierdes, solo perderá 300 EUR/GBP.',
	  'Your deposit on SBOBET is always amount/0.30. This means that if you send 1000 EUR/GBP, we will add 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Su depósito en SBOBET es siempre de /0,30. Esto significa que si envía 1000 EUR/GBP agregaremos 3333,33 (1000/0,30=3333,33) a su cuenta de crédito de SBOBET.',
	  'Likewise, your withdrawal amount is /0.30. This means that if you would like to withdraw 1000 EUR/GBP, we will deduct 3,333.33 (1000/0.30 = 3,333.33) to your SBOBET credit.': 'Igualmente su cantidad de retiro es /0,30. Esto significa que si desea retirar 1000 EUR/GBP, deduciremos 3333,33 (1000/0,30 = 3333,33) de su crédito de SBOBET.',
	  'In AMS Account, amount will appear as EUR/GBP money, however in your SBObet account is SBObet money.': 'En la cuenta AMS aparecerá el dinero EUR/GBP, sin embargo, en su cuenta de SBOBET aparecera el dinero de SBOBET.',
	  '9WICKETS FORCED POSITION TAKING ON ASIANCONNECT': 'POSICION FORZADA QUE ASIANCONNECT TOMA DE 9WICKETS',
	  'Please note that 9wickets have 3% commission rate applied to your winnings.': 'Tenga en cuenta que 9wickets tiene una tasa de comisión del 3% aplicada a sus ganancias',
	  'Please be informed as well that 9wickets is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, 9wickets has the right to close your account and forfeit your balance.': 'Tenga en cuenta también que 9wickets esta haciendo una revisión diaria de todas las apuestas realizadas en su plataforma. Si observan actividades fraudulentas o patrones de apuestas irregulares en su cuenta, 9wickets tiene el derecho de cerrar su cuenta y perder su saldo.',
	  'ORBITX FORCED POSITION TAKING ON ASIANCONNECT': 'POSICION FORZADA QUE ASIANCONNECT TOMA DE ORBITX',
	  'Please note that OrbitX have 3% commission rate applied to your winnings.': 'Tenga en cuenta que OrbitX tiene una tasa de comisión del 3% aplicada a sus ganancias.',
	  'Please be informed as well that OrbitX is doing a daily check of all bets placed on their platform. Should there be fraudulent activity or irregular betting pattern observed in your account, OrbitX has the right to close your account and forfeit your balance.': 'Tenga en cuenta también que OrbitX esta haciendo una revisión diaria de todas las apuestas realizadas en su plataforma. Si observan actividades fraudulentas o patrones de apuestas irregulares en su cuenta, OrbitX tiene el derecho de cerrar su cuenta y perder su saldo.',
	  'SKYPE BETTING TERMS AND CONDITONS ON ASIANCONNECT': 'SKYPE APUESTA TERMINOS Y CONDICIONES EN ASIANCONNECT',
	  'You can contact us via Skype at': 'Puede contactarnos a través de Skype en',
	  'NV for Skype betting Terms and Conditions.': 'NV para los términos y condiciones de las apuestas de Skype.',
	  'Successfully added!': 'Añadido correctamente!',
	  'The following product/s have been added. You may now request deposit into your account. You will receive your product/s username and password once we have received your deposit. Thank you.': 'Se han añadido los siguientes productos. Ahora puede solicitar el depósito en su cuenta. Recibirá su nombre de usuario y contraseña una vez que hayamos recibido su depósito. Gracias',
	  'About Us': 'Sobre Nosotros',
	  'Contact Us': 'Contáctenos',
	  'Legal Disclaimer': 'Nota Legal',
	  'Privacy Policy': 'Política de Privacidad',
	  'Go To Transaction Overview': 'Ir al Resumen de Transacciones',
	  'Notification': 'Notificación',
	  'was deleted.': 'qué borrado.',
	  'Failed to delete': 'Error al eliminar',
	  'file has been uploaded.': 'El archivo ha sido subido',
	  'Failed to upload': 'Error al subir',
	  'Paste an address where you want to receive BTC': 'Pegue la dirección donde quiere recibir sus BTC',
	  'New referral': 'Nuevo referido',
	  'has been linked.': 'ha sido vinculado.',
	  'Referral': 'Referido',
	  'has been unlinked.': 'ha sido desvinculado.',
	  'Product/s': 'Producto/s',
	  'has been added.': 'ha sido añadido.',
	  'Transaction': 'Transacción',
	  'has been': 'ha sido',
	  'Deposit': 'Depositar',
	  'Withdraw': 'Retirar',
	  'Transfer': 'Transferir',
	  'P2P Transfer': 'Transferencia Persona a Persona',
	  'Approved': 'Aprobado',
	  'Acknowledged': 'Admitido',
	  'Processed': 'Procesado',
	  'Saved': 'Salvado',
	  'Invalid Credentials!': 'Credenciales no válidas!',
	  'Email': 'Corre electrónico',
	  'Account ID': 'ID de la cuenta',
	  'Name': 'Nombre',
	  'Request Deposit': 'Realizar depósito',
	  'Request Withdrawal': 'Realizar retirada',
	  'Upload': 'Subir',
	  'W/L': 'W/L',
	  'Bonus': 'Primo',
	  'Revenue Share': 'Participación en los ingresos',
      'Total W/L:': 'Total W/L:',
	  'Total Bonus:': 'Bono Total:',
	  'Total Revenue Share:': 'Ingresos totales compartidos:',
	  'Unlimited': 'Ilimitado',
	  'Instant': 'Inmediato',
	  'My Tickets': 'Mis tickets',
	  'Product is required': 'Se requiere producto',
	  'Transaction password invalid': 'Contraseña de transacción inválida.',
	  'Transaction deposit has been saved': 'La transacción de depósito se ha guardado',
	  'Product has been added': 'El producto se ha añadido',
	  'Transaction withdrawal has been saved': 'La transacción de retirada se ha guardado',
	  'Transaction transfer has been saved': 'Trasferencia guardada',
	  'Transaction deposit has been declined': 'La transacción de depósito ha sido rechazada',
	  'Transaction withdrawal has been declined': 'La transacción de retirada ha sido rechazada',
	  'Transaction transfer has been declined': 'La trasferencia ha sido rechazada',
	  'Transaction deposit has been voided': 'La transacción de depósito ha sido anulada',
	  'Transaction withdrawal has been voided': 'La transacción de retirada ha sido anulada',
	  'Transaction transfer has been voided': 'Trasferencia anulada',
	  'Documents uploaded:': 'Archivos subidos:',
	  'Warning! At least one product is required.': 'Aviso! Al menos un producto es obligatorio.',
	  'paymentOptionsViewDetails': 'Importante: Tras realizar el depósito, rellene este apartado. En caso de error, su depósito no podrá ser realizado. Este mensaje es para notificarnos de su transacción, y poder verificar que se ha reflejado en su cuenta.',
	  'File(s) still uploading, please wait.': 'Los archivos aún se están cargando, por favor espere.',
	  'DEPOSIT': 'DEPOSITOS',
	  'WITHDRAWAL': 'RETIRADAS',
	  'TRANSFER': 'TRANSFERENCIAS',
	  'BONUS': 'PRIMO',
	  'PSP TRANSFER': 'TRANSFERENCIA PERSONA A PERSONA',
	  'COMMISSION': 'COMISION',
	  'DEBIT': 'DÉBITO',
	  'CREDIT': 'CRÉDITO',
	  'REVENUE SHARE': 'PARTICIPACIÓN EN LOS INGRESOS',
	  'RESET BOOKIE PASSWORD': 'RESET BOOKIE CONTRASEÑA',
	  'Ecopayz Merchant Account (EUR)': 'Cuenta mercante Ecopayz (EUR)',
	}
}


// WEBPACK FOOTER //
// ./client/app/shared/locales/locale-es.js